/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import { connect } from 'react-redux'

import { LeaderboardDataGrid } from '../components/DataGrid/LeaderboardDataGrid'
import * as leaderboardSelectors from '../selectors'
import { Dispatch } from 'redux'
import * as selectors from 'app/selectors'
import moment from 'moment'
import { actions } from '../actions'


const { toggleOverrideDisplayLimit } = actions

export interface StateToProps {
    leaderboardSettings?: LeaderboardSettingsDto
    data?: SortableLeaderboardDataRecord[]
    overrideDisplayLimit?: boolean
}

export interface DataGridStateToProps {
    leaderboardSettings?: LeaderboardSettingsDto
    dataGridStyleOptions?: DataGridStyleOptions
    displayEndDateTime?: moment.Moment | string
    displayStartDateTime?: moment.Moment
    dataGridHeaderStyle?: React.CSSProperties
    dataGridEvenStyle?: React.CSSProperties
    dataGridOddStyle?: React.CSSProperties
    titleOptions?: TitleOptions
    overrideDisplayDate?: boolean
    data?: SortableLeaderboardDataRecord[]
    showModule: boolean
    subTitleStyle?: React.CSSProperties
    titleStyle?: React.CSSProperties
    showSubTitle: boolean
    showTitle: boolean
    sortedColumn?: LeaderboardSort
}

export interface DispatchToProps {
    toggleOverrideDisplayLimit: () => void
}

export const mapStateToProps = (state: RootState): StateToProps & DataGridStateToProps => {
    const dataGridHeaderStyle = leaderboardSelectors.getDataGridHeaderOptions(state)
    const dataGridEvenStyle = leaderboardSelectors.getDataGridEvenOptions(state)
    const dataGridOddStyle = leaderboardSelectors.getDataGridOddOptions(state)
    const leaderboardSettings = selectors.getInstanceSettings(state) as LeaderboardSettingsDto | undefined
    const showModule = imod.cms.scoreboards.overrideDisplayDate || leaderboardSelectors.getShowModule(state)
    const titleStyle = leaderboardSelectors.getTitleTextStyle(state) as React.CSSProperties
    const subTitleStyle = leaderboardSelectors.getSubTitleTextStyle(state) as React.CSSProperties
    const sortedColumn = leaderboardSelectors.getLeaderboardSort(state)
    const dataSettings = leaderboardSelectors.getLeaderboardDataSorted(state)
    return {
        data: dataSettings,
        leaderboardSettings,
        overrideDisplayLimit: leaderboardSelectors.getOverrideDisplayLimit(state) || false,
        showModule,
        showSubTitle: Boolean(leaderboardSettings && leaderboardSettings.moduleSubTitle && subTitleStyle && showModule),
        showTitle: Boolean(titleStyle && showModule),
        subTitleStyle,
        titleStyle,
        sortedColumn,
        dataGridHeaderStyle,
        dataGridEvenStyle,
        dataGridOddStyle,
    }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
    toggleOverrideDisplayLimit: () => {
        dispatch(toggleOverrideDisplayLimit())
    },
    sortLeaderboard: (column: keyof SortableLeaderboardDataRecord) => (sortAscending: boolean): void => {
        dispatch(actions.sortLeaderboard({ column, sortAscending } as LeaderboardSort))
    },
})

// @ts-ignore
export const Leaderboard = connect(mapStateToProps, mapDispatchToProps)(LeaderboardDataGrid)
